import {
  name as quiz,
  reducer as quizReducer,
} from '@/components/Player/modules/reducers/quiz';

import {
  name as audioPlayer,
  reducer as audioPlayerReducer,
} from '@/components/Player/modules/reducers/audioPlayer';

import {
  name as videoPlayer,
  reducer as videoPlayerReducer,
} from '@/components/Player/modules/reducers/videoPlayer';

import {
  name as elearningPlayer,
  reducer as elearningPlayerReducer,
} from '@/components/Player/modules/reducers/elearningPlayer';

export default {
  [quiz]: quizReducer,
  [audioPlayer]: audioPlayerReducer,
  [elearningPlayer]: elearningPlayerReducer,
  [videoPlayer]: videoPlayerReducer,
};
